import { JsonPatchOperation } from '@core/data/models/json-patch.model';

export interface CaseTypePrintTemplateAssignment {
  printTemplateId: number;
  isPreselected: boolean;
}

export interface CaseTypeTextBlockCombinationAssignment {
  textBlockCombinationId: number;
  ordinalNumber: number;
}

export interface CaseType {
  id: number;
  name: string;
  isActive: boolean;
  subject?: string | null;
  heading?: string | null;
  damageCategoryId?: number | null;
  gdvDamageCategoryId?: number | null;
  gdvDamageKindId?: number | null;
  featureId?: number | null;
  agencyIds: number[];
  printTemplates: CaseTypePrintTemplateAssignment[];
  textBlockCombinations: CaseTypeTextBlockCombinationAssignment[];
}

export interface CaseTypeView extends CaseType {
  damageCategoryDescription?: string;
  gdvDamageCategoryDescription?: string;
  gdvDamageKindDescription?: string;
}

export function toPatchOperations(
  changes: Partial<CaseType>
): JsonPatchOperation[] {
  const operations: JsonPatchOperation[] = [];

  Object.entries(changes).forEach(([key, value]) => {
    if (value !== undefined) {
      operations.push({
        op: 'replace',
        path: `/${key}`,
        value: value,
      });
    }
  });

  return operations;
}
